// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_aNH","cls2":"CiterightLanding-cls2_7iT CiterightLanding-cls1_aNH"};